const FormsInterfaceSystem = {
  namespaced: true,

  state: {
    isFocusFormTextElement: false,
  },

  mutations: {
    //Отметить/ Снять отметку, что какое-либо текстовое поле имеет фокус 
    toToggleFocusFormTextElement(state, status){
      state.isFocusFormTextElement = status;
    }
  },

  getters:{

  }
}

export default FormsInterfaceSystem;